module.exports = __webpack_public_path__ + "img/batch_edit_user_tags_download.e8cefc81.png";